import { render, staticRenderFns } from "./SettingsTabEmail.vue?vue&type=template&id=511774ad"
import script from "./SettingsTabEmail.vue?vue&type=script&lang=js"
export * from "./SettingsTabEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports